import {getUserData} from '../api/userData';
import listingActions from '../actions/listingActions';
import travelerActions from '../actions/travelerActions';

async function fetchUserData(store) {
    const state = store.getState();
    const system = state.systemReducer;

    const response = await getUserData({useMockLogin: system.useMockLogin});

    if (response.body) {
        store.dispatch(listingActions.fetchUserDataSuccess(response.body));
    }
}

async function fetchUserDataAndSetLoggedIn(store) {
    const state = store.getState();
    const system = state.systemReducer;

    const response = await getUserData({useMockLogin: system.useMockLogin});

    if (response.body) {
        store.dispatch(listingActions.fetchUserDataSuccess(response.body));
        store.dispatch(travelerActions.setUserLoggedIn());
    }
}

export {fetchUserData, fetchUserDataAndSetLoggedIn};
